import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { collection, query, where, orderBy, getDocs, limit } from 'firebase/firestore';
import { IoArrowBack, IoMap, IoCalendar, IoTime, IoPerson, IoShieldCheckmarkOutline } from 'react-icons/io5';
import { useAuth } from '../context/AuthContext';
import { GoogleMap, useJsApiLoader, Polyline, Marker } from '@react-google-maps/api';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import SafeAreaInsets from '../components/Shared/SafeAreaInsets';
import './SeguridadScreen.css';

function RondinesHistoryScreen() {
    const navigate = useNavigate();
    const { userData } = useAuth();
    const [rondines, setRondines] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRondin, setSelectedRondin] = useState(null); // Para mostrar el mapa

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    });

    useEffect(() => {
        const fetchRondines = async () => {
            if (!userData?.condominioId) return;
            try {
                const q = query(
                    collection(db, 'rondines'),
                    where('condominioId', '==', userData.condominioId),
                    orderBy('startTime', 'desc'),
                    limit(50)
                );
                const snapshot = await getDocs(q);
                const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setRondines(list);
            } catch (error) {
                console.error("Error fetching rondines:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchRondines();
    }, [userData]);

    const formatDateTime = (timestamp) => {
        if (!timestamp) return 'N/A';
        const date = timestamp.toDate();
        return date.toLocaleString('es-MX', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    const calculateDuration = (start, end) => {
        if (!start || !end) return 'En proceso';
        const diffInMs = end.toDate() - start.toDate();
        const diffInMins = Math.floor(diffInMs / 60000);
        return `${diffInMins} min`;
    };

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/seguridad" />
            <main className="ks-main">
                <div className="ks-header-sticky-wrapper">
                    <KondoBrandHeader showBack={false} />
                </div>
                <div className="ks-scroll-area">
                    <div className="seguridad-container" style={{ padding: '15px' }}>
                        {/* Header Banner */}
                        <div className="app-header-sticky" style={{ padding: 0, marginBottom: '15px' }}>
                            <div className="kondo-banner-standard" style={{ background: 'linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)', margin: 0 }}>
                                <div className="banner-standard-content">
                                    <button onClick={() => navigate('/seguridad')} className="banner-back-btn-standard">
                                        <IoArrowBack size={24} />
                                    </button>
                                    <div className="banner-standard-text">
                                        <h2>Historial</h2>
                                        <p>Rondines de vigilancia</p>
                                    </div>
                                </div>
                                <div className="banner-standard-actions">
                                    <IoShieldCheckmarkOutline size={22} color="white" style={{ opacity: 0.8 }} />
                                </div>
                                <IoShieldCheckmarkOutline className="banner-standard-icon-decor" />
                            </div>
                        </div>

                        {loading ? (
                            <p style={{ textAlign: 'center', marginTop: '20px', color: '#6b7280' }}>Cargando historial...</p>
                        ) : rondines.length === 0 ? (
                            <div className="empty-state" style={{ textAlign: 'center', marginTop: '40px', color: '#6b7280' }}>
                                <IoMap size={50} style={{ opacity: 0.5, marginBottom: '10px' }} />
                                <p>No hay rondines registrados aún.</p>
                            </div>
                        ) : (
                            <div style={{ display: 'grid', gap: '15px', padding: '0px 0px 20px' }}>
                                {rondines.map(rondin => (
                                    <div
                                        key={rondin.id}
                                        onClick={() => setSelectedRondin(rondin)}
                                        style={{
                                            backgroundColor: 'white', padding: '15px', borderRadius: '12px',
                                            boxShadow: '0 2px 5px rgba(0,0,0,0.05)', cursor: 'pointer',
                                            borderLeft: rondin.status === 'active' ? '4px solid #10b981' : '4px solid #6366f1'
                                        }}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                            <strong style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <IoPerson color="#6b7280" /> {rondin.vigilanteName}
                                            </strong>
                                            <span style={{ fontSize: '0.8rem', color: rondin.status === 'active' ? '#10b981' : '#6b7280', fontWeight: 'bold' }}>
                                                {rondin.status === 'active' ? 'EN PROCESO' : 'COMPLETADO'}
                                            </span>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '0.9rem', color: '#4b5563' }}>
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <IoCalendar color="#9ca3af" />
                                                Inicio: {formatDateTime(rondin.startTime)}
                                            </span>
                                            {rondin.endTime && (
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <IoTime color="#9ca3af" />
                                                    Fin: {formatDateTime(rondin.endTime)} (Duración: {calculateDuration(rondin.startTime, rondin.endTime)})
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <KondoBottomNav activeRoute="/seguridad" />
            </main>

            {/* MAP MODAL */}
            {selectedRondin && isLoaded && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: '#f8fafc', zIndex: 1000,
                    display: 'flex', flexDirection: 'column'
                }}>
                    <KondoBrandHeader showBack={false} />
                    <div style={{ padding: '15px 20px', backgroundColor: 'white', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#1e293b', fontWeight: 'bold' }}>Rondín de {selectedRondin.vigilanteName}</h3>
                            <p style={{ margin: '3px 0 0', fontSize: '0.8rem', color: '#64748b' }}>
                                {formatDateTime(selectedRondin.startTime)}
                            </p>
                        </div>
                        <button
                            onClick={() => setSelectedRondin(null)}
                            style={{
                                background: '#ef4444', color: 'white', border: 'none', padding: '8px 16px',
                                borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer', fontSize: '0.9rem',
                                transition: 'background 0.2s'
                            }}
                        >
                            Cerrar
                        </button>
                    </div>
                    <div style={{ flex: 1, position: 'relative' }}>
                        <GoogleMap
                            mapContainerStyle={{ width: '100%', height: '100%' }}
                            center={selectedRondin.path?.length > 0 ? selectedRondin.path[0] : { lat: 19.4326, lng: -99.1332 }}
                            zoom={18}
                            options={{ disableDefaultUI: true, zoomControl: true }}
                        >
                            {selectedRondin.path?.length > 0 && (
                                <>
                                    <Polyline
                                        path={selectedRondin.path}
                                        options={{ strokeColor: "#FF0000", strokeOpacity: 0.8, strokeWeight: 4 }}
                                    />
                                    <Marker position={selectedRondin.path[0]} label="Inicio" />
                                    {selectedRondin.path.length > 1 && (
                                        <Marker position={selectedRondin.path[selectedRondin.path.length - 1]} label="Fin" />
                                    )}
                                </>
                            )}
                        </GoogleMap>
                    </div>
                </div>
            )}
        </div>
    );
}

export default RondinesHistoryScreen;
